import { BehaviorSubject } from "rxjs";

export const KPISubject = new BehaviorSubject({});
